import React, { memo } from "react";

export type TooltipProps = {
  children: React.ReactNode;
  message: string;
};

const ToolTip: React.FC<TooltipProps> = memo((props) => {
  return (
    <span className="group relative">
      <span className="pointer-events-none absolute top-1/2 left-full -translate-y-1/2 ml-2 whitespace-nowrap rounded bg-black-900 px-2 py-1 text-white-A700 opacity-0 transition before:absolute before:top-1/2 before:left-0 before:-translate-y-1/2 before:-translate-x-full before:border-4 before:border-transparent before:border-r-black-900 before:content-[''] group-hover:opacity-100 z-50 lg:top-auto lg:left-1/2 lg:-translate-x-1/2 lg:bottom-full lg:mb-2 lg:ml-0 lg:translate-y-0 lg:before:top-auto lg:before:bottom-0 lg:before:left-1/2 lg:before:-translate-x-1/2 lg:before:-translate-y-full lg:before:border-r-0 lg:before:border-t-black-900 xl:top-1/2 xl:left-full xl:-translate-y-1/2 xl:translate-x-0 xl:bottom-auto xl:mb-0 xl:ml-2 xl:before:top-1/2 xl:before:left-0 xl:before:-translate-y-1/2 xl:before:-translate-x-full xl:before:border-t-0 xl:before:border-r-black-900 xl:before:border-b-0 xl:before:border-l-0">
        {props.message}
      </span>

      {props.children}
    </span>
  );
});

ToolTip.displayName = "Tooltip";

export default ToolTip;

// "pointer-events-none absolute -top-10 left-1/2 -translate-x-1/2 whitespace-nowrap rounded bg-black px-2 py-1 text-white opacity-0 transition before:absolute before:left-1/2 before:top-full before:-translate-x-1/2 before:border-4 before:border-transparent before:border-t-black before:content-[''] group-hover:opacity-100"